import styled, { css } from 'styled-components';
import {
  colors,
  extraLargeShadow,
  spacing,
  zIndex,
  duration,
  easing,
  slideFromRight,
} from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { PanelSize, TakeOverProps } from './TakeOver.types';

const SIZE_WIDTHS = {
  [PanelSize.FullWidth]: '100%',
  [PanelSize.Xlarge]: `calc(100vw - ${spacing.x4})`,
  [PanelSize.Large]: pxToRem(928),
  [PanelSize.Medium]: pxToRem(672),
  [PanelSize.Small]: pxToRem(525),
};

export const TakeOverContainer = styled.div<TakeOverProps>`
  display: flex;
  position: fixed;
  width: 100%;
  height: 100%;
  right: 0;
  top: 0;
  flex-direction: column;
  align-items: stretch;
  flex-shrink: 0;
  z-index: ${zIndex.takeOver};
`;

export const TakeOverPanel = styled.div<{ size?: PanelSize }>`
  flex: 1 1 auto;
  overflow: auto;
  align-self: flex-end;
  align-items: stretch;
  background: ${colors.white};
  display: flex;
  flex-direction: column;
  ${extraLargeShadow};
  width: ${({ size }) => (size ? SIZE_WIDTHS[size] : 'auto')};
  ${({ size }) =>
    size === PanelSize.Small || size === PanelSize.Medium
      ? css`
          animation: ${slideFromRight} ${duration.long} ${easing.entrance};
        `
      : ''};
`;
